import { Selectors3asFPermissions } from '@va/aaas/shared/selectors';
import { moduleNames } from '@va/constants';
import { modulePermissionsSlice } from '@va/dashboard/slices';
import { is3asApp, isMetaDataAnalyticsEnabled, isTrendIntelEnabled } from '@va/util/helpers';
import { createSelector } from 'reselect';

const { selectPermissions } = modulePermissionsSlice.getSelectors((state: any) =>
  state.get('core').get('modulePermissions'),
);

export const isContentAnalysisModuleEnabled = (state: any) => {
  const flagEnabled = isMetaDataAnalyticsEnabled();

  if (is3asApp()) {
    return Selectors3asFPermissions.isEnabled.contentAnalysis(state) || flagEnabled;
  }

  return flagEnabled;
};

const isModuleEnabled = createSelector(
  selectPermissions,
  isContentAnalysisModuleEnabled,
  (permissions, contentAnalysisModuleEnabled) => {
    return (moduleName: string) => {
      const isAllowedForRole = !permissions?.find((item) => item.module === moduleName)?.disabled;

      if (moduleName === moduleNames.metadataAnalytics) {
        return contentAnalysisModuleEnabled;
      }

      if (moduleName === moduleNames.trendIntel) {
        return isAllowedForRole && isTrendIntelEnabled();
      }

      return isAllowedForRole;
    };
  },
);

export const modulePermissionsSelectors = {
  selectPermissions,
  isModuleEnabled,
};
